var SDK_VERSION = '7.101.0';
export { SDK_VERSION };